import { ProviderExtension } from "../registry";
import { AppleAdvancedToggles } from "./AppleAdvancedToggles";
import { AppleP8Fields } from "./AppleP8Fields";
import { AppleWebSecretMethod } from "./AppleWebSecretMethod";

export const appleExtension: ProviderExtension = {
  labels: {
    nativeAudienceLabel: "Bundle IDs",
    nativeAudiencePlaceholder: "com.example.app, com.example.app.dev",
    nativeAudienceHint: "Use the iOS app's bundle identifier(s).",
    webClientIdLabel: "Service ID",
    webClientIdPlaceholder: "com.example.app.signin",
  },
  WebSecretMethod: AppleWebSecretMethod,
  WebSecretBody: AppleP8Fields,
  webSecretBodyShownWhen: (state) => state.appleWebMethod === "p8",
  hideGenericClientSecretWhen: (state) => state.appleWebMethod === "p8",
  Advanced: AppleAdvancedToggles,
  buildPayloadExtras(state, payload) {
    if (state.appleWebMethod === "p8") {
      // Blank textarea preserves the existing key — only forward when non-empty.
      if (state.applePrivateKey.trim()) {
        payload.apple_private_key = state.applePrivateKey;
      }
      payload.apple_key_id = state.appleKeyId.trim();
      payload.apple_team_id = state.appleTeamId.trim();
    }
    payload.allow_missing_email = state.allowMissingEmail;
  },
  shouldSkipDefaultClientSecret: (state) => state.appleWebMethod === "p8",
};
